import type { ContentReferenceContext } from '@gitbook/app-database';
import { buttons } from '@gitbook/doc-core';
import type { HiveClient } from '@gitbook/hive-client';
import { isBlockRangeSelection, type TextRange } from '@gitbook/slate';
import type { EditorContainer } from '@gitbook/slate-react';

import { createInputContentRefPalette } from '../../ContentReferences';

/**
 * Create a button insertion palette.
 */
export function createButtonPalette(args: {
    editor: EditorContainer;
    getRange?: () => TextRange;
    contentReferenceContext: ContentReferenceContext;
    hiveClient: HiveClient;
}) {
    const { editor, getRange, contentReferenceContext, hiveClient } = args;
    return createInputContentRefPalette(
        (ref) => {
            editor.change((change) => {
                const textRange = getRange ? getRange() : change.value.selection;

                if (isBlockRangeSelection(textRange)) {
                    return change;
                }

                change.insertInlineAtRange(textRange, buttons.createInlineButton({ ref })).focus();
            });
        },
        { ...contentReferenceContext, document: editor.value.document },
        hiveClient,
        { accept: ['url', 'anchor', 'page', 'space'] }
    );
}
